export const moBenefitData = [
  {
    imgSrc:"./images/main/benefit/m_benefit01.jpg",
    title:"앱다운로드 안내",
  },
  {
    imgSrc:"./images/main/benefit/m_benefit02.jpg",
    title:"멤버쉽 안내",
  },
];